export const BASE = 0;
export const ABOVE = 1;
export const BELOW = -1;
